import { ConvexReactClient } from "convex/react";

declare const __CONVEX_URL__: string;

let client: ConvexReactClient | null = null;

export function getConvexClient(): ConvexReactClient {
  if (!client) {
    if (!__CONVEX_URL__) {
      throw new Error("CONVEX_URL is not configured");
    }
    client = new ConvexReactClient(__CONVEX_URL__);
  }
  return client;
}
